import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Card, Loader } from 'shared-components';
import { Tooltip } from 'react-tippy';
import {
  CategoriesContainer,
  CategoryItem,
  DashboardStatus,
  ServiceItem,
  ServicesContainer,
  StatusDetail,
} from '../styles';
import { STATUSCATEGORIES } from '../../../utils/config';
import useTellerApi from '../../../hooks/useTellerApi';
import ClientErrorComponent from '../../../components/ClientErrorComponent';
import { ServiceConfigContext } from '../../../context/ServiceConfigContext';

function SystemStatusDashboard() {
  const serviceConfiguration = useContext(ServiceConfigContext);
  const [
    {
      data: { services, status },
      isLoading,
      isError,
    },
  ] = useTellerApi('/api/v1/client_portal/uptimes/status', {});

  const messages = {
    operational: 'All Systems Operational',
    maintenance: 'Some systems are under maintenance',
    degraded_performance: 'Some systems are experiencing degraded performance',
    partial_outage: 'Some systems are facing partial outage',
    major_outage: 'Major outage affecting multiple systems',
  };
  const overallStatus = {
    icon: STATUSCATEGORIES.find(s => s.id === (status || 'operational')).icon,
    message: messages[status] || 'All Systems Operational',
  };
  return (
    <Card className="mb-3">
      {isLoading && <Loader />}
      {!isLoading && isError && <ClientErrorComponent data={{}} />}
      {!isLoading && !isError && (
        <>
          <DashboardStatus>
            {overallStatus.icon && overallStatus.icon}
            <h3>{overallStatus.message}</h3>
          </DashboardStatus>
          {serviceConfiguration.enable_incident_portal_details && (
            <StatusDetail>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.96002 3.3602C7.60203 3.6887 6.36088 4.38519 5.37294 5.37313C4.38501 6.36106 3.68852 7.60222 3.36002 8.9602C2.83808 10.9533 2.83808 13.0471 3.36002 15.0402C3.68852 16.3982 4.38501 17.6393 5.37294 18.6273C6.36088 19.6152 7.60203 20.3117 8.96002 20.6402C10.9867 21.1202 13.0134 21.1202 15.04 20.6402C16.398 20.3117 17.6392 19.6152 18.6271 18.6273C19.615 17.6393 20.3115 16.3982 20.64 15.0402C21.162 13.0471 21.162 10.9533 20.64 8.9602C20.3115 7.60222 19.615 6.36106 18.6271 5.37313C17.6392 4.38519 16.398 3.6887 15.04 3.3602C13.047 2.83827 10.9531 2.83827 8.96002 3.3602ZM10.48 11.7202L10.84 11.4002L11.88 12.9202L12.28 13.4802C12.44 13.6669 12.68 13.8002 13 13.8802C13.2819 13.9101 13.5653 13.8393 13.8 13.6802L14.36 13.2402L16.08 11.6802C16.1613 11.5611 16.2 11.4181 16.1899 11.2743C16.1797 11.1304 16.1213 10.9942 16.0241 10.8878C15.9269 10.7813 15.7966 10.7108 15.6543 10.6876C15.5119 10.6645 15.366 10.69 15.24 10.7602L13.52 12.2802L13.16 12.6002L12.88 12.2002L12.12 11.0402L11.72 10.4802C11.5347 10.2661 11.2797 10.1244 11 10.0802C10.7181 10.0503 10.4347 10.1211 10.2 10.2802L9.64002 10.7202L7.92002 12.2802C7.83568 12.3272 7.76306 12.3926 7.70761 12.4717C7.65215 12.5507 7.61529 12.6412 7.59979 12.7365C7.58429 12.8318 7.59054 12.9294 7.61809 13.0219C7.64563 13.1144 7.69376 13.1995 7.75885 13.2708C7.82395 13.3421 7.90433 13.3978 7.99398 13.4336C8.08363 13.4694 8.18022 13.4845 8.27652 13.4777C8.37282 13.4709 8.46634 13.4424 8.55007 13.3944C8.6338 13.3463 8.70558 13.2799 8.76002 13.2002L10.48 11.7202ZM10.84 11.4002L11.88 12.9202L11.08 11.8002L10.84 11.4002Z"
                  fill="#482764"
                />
              </svg>
              <p>Detailed status for all services can be viewed here.</p>
              <Link to="/system-incidents">
                View Incidents{' '}
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.48 9.48H2.496V2.496H5.988V1.5H2.496C2.216 1.5 1.98 1.59787 1.788 1.7936C1.596 1.98933 1.5 2.22347 1.5 2.496V9.48C1.5 9.76 1.596 9.996 1.788 10.188C1.98 10.38 2.216 10.476 2.496 10.476H9.48C9.76 10.476 9.996 10.38 10.188 10.188C10.38 9.996 10.476 9.76 10.476 9.48V5.988H9.48V9.48ZM6.984 1.5V2.496H8.784L3.876 7.404L4.572 8.1L9.48 3.204V4.992H10.476V1.5H6.984Z"
                    fill="white"
                  />
                </svg>
              </Link>
            </StatusDetail>
          )}
          <CategoriesContainer>
            {STATUSCATEGORIES.map(item => (
              <CategoryItem key={item.id} title={item.description}>
                {item.icon}
                {item.name}
              </CategoryItem>
            ))}
          </CategoriesContainer>
          <ServicesContainer>
            {services.map(item => (
              <ServiceItem key={item.name}>
                <div>
                  {STATUSCATEGORIES.find(cat => cat.id === item.category)
                    .icon || ''}
                  <p>{item.name}</p>
                </div>
                <Tooltip
                  title={item.description}
                  position="bottom"
                  trigger="mouseenter"
                  interactive
                  interactiveBorder={10}
                  delay={1}
                  arrow
                  theme="light"
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="info-icon"
                  >
                    <path
                      d="M2.24 5.9733C2.459 5.06798 2.92333 4.24055 3.58195 3.58192C4.24058 2.9233 5.06801 2.45897 5.97334 2.23997C7.30204 1.89201 8.69796 1.89201 10.0267 2.23997C10.932 2.45897 11.7594 2.9233 12.4181 3.58192C13.0767 4.24055 13.541 5.06798 13.76 5.9733C14.108 7.30201 14.108 8.69793 13.76 10.0266C13.541 10.932 13.0767 11.7594 12.4181 12.418C11.7594 13.0766 10.932 13.541 10.0267 13.76C8.69796 14.1079 7.30204 14.1079 5.97334 13.76C5.06801 13.541 4.24058 13.0766 3.58195 12.418C2.92333 11.7594 2.459 10.932 2.24 10.0266C1.89205 8.69793 1.89205 7.30201 2.24 5.9733Z"
                      fill="#363853"
                      fillOpacity="0.15"
                      stroke="#363853"
                      strokeWidth="1.26667"
                    />
                    <path
                      d="M8 10.3467V7.68005"
                      stroke="#363853"
                      strokeWidth="1.26667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8.34666 5.99998C8.34666 6.09192 8.31014 6.1801 8.24512 6.24511C8.18011 6.31013 8.09194 6.34665 7.99999 6.34665C7.91275 6.33992 7.83128 6.30044 7.77193 6.23615C7.71258 6.17185 7.67973 6.08749 7.67999 5.99998C7.70069 5.92754 7.74441 5.86382 7.80456 5.81845C7.8647 5.77308 7.93799 5.74854 8.01333 5.74854C8.08867 5.74854 8.16195 5.77308 8.2221 5.81845C8.28224 5.86382 8.32597 5.92754 8.34666 5.99998Z"
                      fill="#363853"
                      fillOpacity="0.15"
                      stroke="#363853"
                      strokeWidth="0.833333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Tooltip>
              </ServiceItem>
            ))}
          </ServicesContainer>
        </>
      )}
    </Card>
  );
}

export default SystemStatusDashboard;
